import React from 'react';
import * as S from './claim-timeline.styles';

export interface ITimelineEventChipProps {
    icon?: string;
    label: string;
    badge?: string;
    secondaryType?: React.ReactNode;
}

export const TimelineEventChip = React.memo<ITimelineEventChipProps>(({ icon, label, badge, secondaryType }) => (
    <S.EventChipWrap>
        <S.EventChip>
            {icon && <S.EventChipIcon path={icon} size={0.75} />}
            <S.EventChipLabel>{label}</S.EventChipLabel>
        </S.EventChip>
        {badge && <S.EventChipBadge>{badge}</S.EventChipBadge>}
        {secondaryType}
    </S.EventChipWrap>
));
